export const themeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2', // default theme
    },
    secondary: {
      main: '#9c27b0', // default theme
    },
  },
  typography: {
    fontFamily: 'system-ui',
  },
};